(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jovani-availability"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-jovani-availability]').forEach(function (root) {
    const dialog = root.querySelector('[data-availability-dialog]');
    const closeButton = root.querySelector('[data-availability-close]');
    const title = root.querySelector('[data-availability-title]');
    const choice = root.querySelector('[data-availability-choice]');
    const result = root.querySelector('[data-availability-result]');
    const override = root.dataset.styleOverride.trim();
    const titleMatch = root.dataset.productTitle.match(/Jovani\s+([A-Za-z0-9-]+)/i);
    const style = override || (titleMatch ? titleMatch[1] : '');
    const variantsNode = root.querySelector('[data-jovani-variants]');
    const optionsNode = root.querySelector('[data-jovani-options]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent || '[]') : [];
    const optionNames = optionsNode ? JSON.parse(optionsNode.textContent || '[]') : [];
    let availability = null;
    let loading = null;
    let lastCombination = '';
    let lastAnchor = null;
    if (!style || !dialog) return;

    closeButton.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    document.addEventListener('change', function (event) {
      if (!isProductOption(event.target)) return;
      lastAnchor = event.target;
      window.setTimeout(showSelectedAvailability, 80);
    });
    document.addEventListener('click', function (event) {
      const option = event.target.closest('input[type="radio"], select, [data-option-value], [data-value], button[name^="option"]');
      if (!option) return;
      if (!isProductOption(option)) return;
      lastAnchor = option;
      window.setTimeout(showSelectedAvailability, 80);
    });
    document.addEventListener('variant:change', function (event) {
      lastAnchor = event.target;
      window.setTimeout(showSelectedAvailability, 20);
    });

    async function showSelectedAvailability() {
      const selection = getSelection();
      if (!selection.color || !selection.size) return;
      const combination = normalize(selection.color) + '|' + normalize(selection.size);
      if (combination === lastCombination && dialog.open) return;
      lastCombination = combination;
      title.textContent = root.dataset.checking;
      choice.textContent = selection.color + ' · Size ' + selection.size;
      result.className = 'jovani-availability__result';
      result.textContent = root.dataset.loading;
      positionDialog();
      if (!dialog.open) dialog.show();
      try {
        const payload = await loadAvailability();
        const item = findItem(payload, selection);
        if (!item) {
          title.textContent = root.dataset.contact;
          result.textContent = root.dataset.unconfirmed;
          return;
        }
        title.textContent = item.status === 'available' ? root.dataset.available : root.dataset.soldOut;
        result.classList.add('jovani-availability__result--' + item.status);
        result.innerHTML = escapeHtml(item.message) + (item.restockDate ? '<span class="jovani-availability__restock">' + escapeHtml(root.dataset.restock) + ': ' + escapeHtml(item.restockDate) + '</span>' : '');
      } catch (error) {
        title.textContent = root.dataset.contact;
        result.textContent = root.dataset.loadError;
      }
    }

    function positionDialog() {
      const picker = lastAnchor && lastAnchor.getBoundingClientRect ? lastAnchor : findProductPicker();
      if (!picker || window.matchMedia('(max-width: 749px)').matches) return;
      const rect = picker.getBoundingClientRect();
      const width = Math.min(390, window.innerWidth - 32);
      const left = Math.max(16, Math.min(rect.left, window.innerWidth - width - 16));
      dialog.style.width = width + 'px';
      dialog.style.left = left + 'px';
      dialog.style.top = Math.min(rect.bottom + 12, window.innerHeight - 260) + 'px';
    }

    function getSelection() {
      const selected = { color: '', size: '' };
      const variant = selectedVariant();
      if (variant && Array.isArray(variant.options)) {
        optionNames.forEach(function (name, index) {
          const optionName = String(name || '').toLowerCase();
          if (optionName.includes('color') || optionName.includes('colour')) selected.color = String(variant.options[index] || '');
          if (optionName.includes('size')) selected.size = String(variant.options[index] || '');
        });
      }
      if (selected.color && selected.size) return selected;
      const picker = findProductPicker();
      if (!picker) return selected;
      picker.querySelectorAll('input[type="radio"]:checked, select, input[type="hidden"][name^="options"]').forEach(function (control) {
        if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) return;
        const legend = control.closest('fieldset') ? control.closest('fieldset').querySelector('legend') : null;
        const group = control.closest('[data-option-name], [data-option-index], .product-form__input');
        const optionName = ((legend ? legend.textContent : '') || (group ? group.dataset.optionName : '') || control.getAttribute('aria-label') || control.name || '').toLowerCase();
        if (optionName.includes('color') || optionName.includes('colour')) selected.color = control.value;
        if (optionName.includes('size')) selected.size = control.value;
      });
      return selected;
    }

    function selectedVariant() {
      const forms = document.querySelectorAll('form[action*="/cart/add"], product-form form');
      for (const form of forms) {
        const idInput = form.querySelector('[name="id"]');
        if (idInput && idInput.value) {
          const found = variants.find(function (variant) { return String(variant.id) === String(idInput.value); });
          if (found) return found;
        }
      }
      const variantId = new URL(window.location.href).searchParams.get('variant');
      return variants.find(function (variant) { return String(variant.id) === String(variantId); }) || null;
    }

    function findProductPicker() {
      return document.querySelector('variant-selects, variant-radios, [data-product-variants], .product-form__input, form[action*="/cart/add"]');
    }

    function isProductOption(element) {
      if (!element || !element.closest) return false;
      return Boolean(element.closest('variant-selects, variant-radios, [data-product-variants], .product-form__input, form[action*="/cart/add"]'));
    }

    function loadAvailability() {
      if (availability) return Promise.resolve(availability);
      if (loading) return loading;
      loading = fetch(root.dataset.apiUrl + '/api/availability?designer=Jovani&style=' + encodeURIComponent(style))
        .then(function (response) { return response.json().then(function (payload) { if (!response.ok || !payload.result) throw new Error(); return payload.result; }); })
        .then(function (data) { availability = data; return data; });
      return loading;
    }

    function findItem(payload, selection) {
      const color = payload.colors.find(function (group) { return normalize(group.color) === normalize(selection.color); });
      if (!color) return null;
      return color.sizes.find(function (item) { return normalize(item.size) === normalize(selection.size); }) || null;
    }

    function normalize(value) { return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
    function escapeHtml(value) { const node = document.createElement('span'); node.textContent = String(value || ''); return node.innerHTML; }
  });

  } catch(e) { console.error(e); }
})();
})();
